// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  bodyTemplate: __t.string().name("body_template"),
  skeletonId: __t.string().name("skeleton_id"),
  materialSlots: __t.string().name("material_slots"),
  attachments: __t.string(),
  complexity: __t.u32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
